/**
 * Collection card / quick view Quote buttons.
 * Uses SA Request a Quote GRFQApp.addProduct, same as the product page button.
 * Does not relocate or restyle product-page quote buttons.
 */
(() => {
  const SELECTOR = '[data-card-quote]';

  function addToQuote(button) {
    const productId = Number(button.getAttribute('data-product-id'));
    if (!productId) return false;

    if (window.GRFQApp && typeof window.GRFQApp.addProduct === 'function') {
      window.GRFQApp.addProduct(button, productId);
      return true;
    }
    return false;
  }

  function handleClick(event) {
    const button = event.target.closest(SELECTOR);
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    if (addToQuote(button)) return;

    let attempts = 0;
    const timer = setInterval(() => {
      attempts += 1;
      if (addToQuote(button) || attempts > 20) clearInterval(timer);
    }, 150);
  }

  document.addEventListener('click', handleClick, true);
})();
